import { createSlice } from "@reduxjs/toolkit";
import { environment } from "../environment";

const initialState = {
  isDbInitialized: false,
  // API base URL — same value as Utils/Interceptor.js.
  url: environment.API_PATH,
};

export const DBSlice = createSlice({
  name: "dbSlice",
  initialState,
  reducers: {
    setDbStatus: (state, action) => {
      state.isDbInitialized = action.payload;
    },
  },
});

export const { setDbStatus } = DBSlice.actions;

export default DBSlice.reducer;
